/**
 * How old the school is, computed rather than typed.
 *
 * The public site said "over 38 years" as a literal, which meant someone had
 * to remember to bump it every February - and nobody did: by August 2026 the
 * school was already 39. Every place that states the age now derives it from
 * the founding date, so it turns over by itself on each anniversary.
 */

/** The Children's Hour Academy opened February 1, 1987. */
export const FOUNDED = { year: 1987, month: 2, day: 1 };

/** Completed years since founding - 39 through Jan 31 2027, 40 from Feb 1. */
export function yearsSinceFounding(now: Date = new Date()): number {
  const anniversaryPassed =
    now.getMonth() + 1 > FOUNDED.month ||
    (now.getMonth() + 1 === FOUNDED.month && now.getDate() >= FOUNDED.day);
  return now.getFullYear() - FOUNDED.year - (anniversaryPassed ? 0 : 1);
}
